module.exports = __webpack_public_path__ + "img/ski2.7802ce0d.png";